import type { Database } from 'node-sqlite3-wasm';

export function applySqliteConcurrencyPragmas(db: Database): void {
  try {
    db.run('PRAGMA foreign_keys = ON');
  } catch {
    /* ignore */
  }
  try {
    db.exec('PRAGMA journal_mode = WAL');
  } catch {
    /* ignore */
  }
  try {
    db.run('PRAGMA synchronous = NORMAL');
  } catch {
    /* ignore */
  }
  try {
    db.run('PRAGMA busy_timeout = 500');
  } catch {
    /* ignore */
  }
}

export function applySqliteMemoryPragmas(db: Database): void {
  try {
    db.run('PRAGMA cache_size = -8192');
    db.run('PRAGMA temp_store = FILE');
  } catch {
    /* ignore */
  }
}
